<template>
  <div class="compressed-content">
    <h3>How tall are you?</h3>
    <div class="page-buttons row">
      <v-form-group class="col-12 col-lg-4" :validator="$v.selectedFeet" label="Feet">
          <v-select :class="[{ 'vs--has-value': selectedFeet !== null }, 'height-form']"
                    v-model="selectedFeet"
                    :options="feetOptions"
                    @input="convertToInches"
                    placeholder="Feet" />
      </v-form-group>
      <v-form-group class="col-12 col-lg-4" :validator="$v.selectedInches" label="Inches">
          <v-select :class="[{ 'vs--has-value': selectedInches !== null }, 'height-form']"
                    v-model="selectedInches"
                    :options="inchesOptions"
                    @input="convertToInches"
                    placeholder="Inches" />
      </v-form-group>
    </div>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required } from "vuelidate/lib/validators";

  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  import productType from 'enums/product-type';

  export default {
    mixins: [formMixin],

    data() {
      return {
        productType,
        selectedInches: null,
        selectedFeet: null,
      }
    },

    validations: {
      selectedFeet: {
        required,
      },

      selectedInches: {
        required,
      },
    },

    created() {
      if (this.survey.height) {
        this.selectedFeet = Math.trunc(this.survey.height / 12);
        this.selectedInches = this.survey.height % 12;
      }
    },

    computed: {
      ...mapState(["survey"]),

      feetOptions() {
        let options = [];
        [...Array(5).keys()].map(i => { return { value: i + 3, label: String(i + 3) } }).forEach(i => options.push(i));
        return options;
      },

      inchesOptions() {
        let options = [];
        [...Array(12).keys()].map(i => { return { value: i, label: String(i) } }).forEach(i => options.push(i));
        return options;
      }
    },

    methods: {
      convertToInches() {
        if (this.selectedFeet !== null && this.selectedInches !== null) {
          let result = this.selectedFeet.value * 12 + this.selectedInches.value;
          this.survey.height = result;
        }
      }
    }
  };
</script>